// extracted by mini-css-extract-plugin
export var divider = "_2k-0";
export var dividerText = "_2k-1";